import { render, staticRenderFns } from "./add-interview-review.vue?vue&type=template&id=a729f534"
import script from "./add-interview-review.vue?vue&type=script&lang=js"
export * from "./add-interview-review.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports